import { useEffect, useState } from 'react';
import { checkUserProductAccess_ } from 'hooks/datahook/platformSettings';
import { useAuth } from 'hooks/useAuth';

export const useProductAccess = (productCode) => {
    const { user } = useAuth();
    const [hasAccess, setHasAccess] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAccess = async () => {
            if (!user?.id || !productCode) {
                setHasAccess(false);
                setLoading(false);
                return;
            }

            try {
                const result = await checkUserProductAccess_({
                    userId: user.id,
                    productCode: productCode,
                });
                setHasAccess(result?.data?.isAllowed === true);
            } catch (error) {
                console.error('Failed to check product access:', error);
                setHasAccess(false);
            } finally {
                setLoading(false);
            }
        };

        checkAccess();
    }, [user?.id, productCode]);

    return { hasAccess, loading };
};
